<template>
  <div class="my-pooq-content-body">
    <portal to="delete-edit-header">
      <div class="inquiry-top">
        <ul class="editor-edit">
          <li>
            <a :href="userQnaUrl" class="txt-inquiry-common">
              <span class="txt-inquiry">1:1 문의하기</span>
              <NextButtonWhite/>
            </a>
          </li>
        </ul>
      </div>
    </portal>
    <div class="my-inquiry-top">
      <p class="inquiry-notice">Wavve 서비스 이용 시 불편사항이나 문의사항을 1:1 문의로 보내주시면 신속하고 친절하게 안내해 드리겠습니다!</p>
      <a href="#" @click.prevent="moveToInquiry" class="inquiry-link">1:1 문의하기</a>
    </div>
    <div class="mypooq-list"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200">
      <template v-if="loginState">

        <my-pooq-empty-list v-if="showEmptyList" info-text="문의 내역이 없어요."></my-pooq-empty-list>
        <div v-else-if="!showEmptyList">
          <h2 class="inquiry-section-title">나의 문의 내역</h2>
          <ul class="inquiry-list">
            <li v-for="(qna, index) in qnaList" :key="'qna_' + index">
              <span :class="qna.open ? 'inquiry-box' : 'inquiry-box preview'">
                <div class="badge-group">
                  <span :class="qnaStatusClass(qna)">{{status(qna)}}</span>
                </div>
                <span class="inquiry-title">
                  <span class="title">{{title(qna)}}</span>
                  <span class="date">{{regdate(qna)}}</span>
                </span>
              </span>
              <button type="button" class="btn-inquiry-toggle" @click.prevent="()=>toggleQna(qna)">
                <OpenIcon v-if="!qna.open"/>
                <CloseIcon v-if="qna.open"/>
              </button>
              <template v-if="!qna.open">
                <span class="question-preview">
                  <span class="qna-box" v-html="qna.contents"></span>
                </span>
              </template>
              <template v-else-if="qna.open">
                <span class="question-detail">
                <ul>
                  <li>
                    <span class="answer-hd">이름</span>
                    <span>{{name(qna)}}</span>
                 </li>
                 <li>
                   <span class="answer-hd">이메일</span>
                   <span>{{email(qna)}}</span>
                 </li>
                 <li>
                   <span class="answer-hd">연락처</span>
                   <span>{{phone(qna)}}</span>
                 </li>
                 <li>
                  <span class="answer-hd">질문 구분</span>
                  <span>{{questiontype(qna)}}</span>
                </li>
                <li>
                  <span class="answer-hd">서비스 구분</span>
                  <span>{{servicetype(qna)}}</span>
                </li>
                <li>
                  <span class="answer-hd">프로그램 정보</span>
                  <span>{{programinfo(qna)}}</span>
                </li>
                <li>
                  <span class="answer-hd">사용환경1</span>
                  <span>{{env_1(qna)}}</span>
                </li>
                <li>
                  <span class="answer-hd">사용환경2</span>
                  <span>{{env_2(qna)}}</span>
                </li>
                </ul>
                <span class="qna-box">
                    <strong class="content">내용</strong>
                    <span v-html="qna.contents"></span>
                </span>
                <span :class="index === 0 ? 'answer-content' : 'answer-content re-answer'" v-for="(answer, index) in qna.answers" :key="qna.qnaid + 'answer_' + index">
                    <span v-html="answer.answer"></span>
                    <span class="date">{{regdate(answer)}}</span>
                </span>
              </span>
                <button type="button" class="btn-delete" @click.prevent="()=>deleteQna(qna)">삭제</button>
              </template>
            </li>
          </ul>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import utils from '@/common/util/utils'
import { infiniteScroll } from '@/common/directives'
import OpenIcon from '@/assets/svg/common/ic_open_w.svg'
import CloseIcon from '@/assets/svg/common/ic-closd-w.svg'
import InquiryCallIcon from '@/assets/svg/common/ic-cst-call.svg'
import { MyPooqService } from '@/common/api/api.service'
import { get, indexOf } from 'lodash'
import { MSG_ASK_DELETE_USER_QNA } from '@/common/constant'
import NextButtonWhite from '@/assets/svg/common/ic-next-s-w.svg'
import { isApp } from '@/common/util/common'

export default {
  name: 'UserQna',
  components: {
    MyPooqEmptyList,
    OpenIcon,
    CloseIcon,
    NextButtonWhite,
    InquiryCallIcon
  },
  directives: {
    infiniteScroll
  },
  data () {
    return {
      offset: 0,
      limit: 10,
      showEmptyList: false,
      endOfList: false,
      totalCount: 0,
      qnaList: [],
      offsetData: [],
      loginState: utils.cookies.getCredential() !== 'none'
    }
  },
  methods: {
    async deleteQna (qna) {
      if (await utils.asyncConfirm(MSG_ASK_DELETE_USER_QNA)) {
        MyPooqService.deleteQna({ qnaid: qna.qnaid }).then(() => {
          this.offset = 0
          this.limit = 10
          this.showEmptyList = false
          this.totalCount = 0
          this.qnaList = []
          this.offsetData = []
          this.setData()
        })
      }
    },
    toggleQna (qna) {
      qna.open = !qna.open
    },
    loadMore () {
      if (this.endOfList) return
      this.setData()
    },
    setData () {
      if (indexOf(this.offsetData, this.offset) > -1 || !this.loginState) return
      this.offsetData.push(this.offset)
      MyPooqService.userQna({ offset: this.offset, limit: this.limit, orderby: 'new' })
        .then(({ data }) => {
          const resList = get(data, 'list', []).map((item) => {
            item.open = false
            return item
          })
          if (this.totalCount === 0) {
            this.totalCount = Number(get(data, ['0', 'pagecount'], 0))
          }
          this.endOfList = resList.length === 0
          this.showEmptyList = this.qnaList.length === 0 && resList.length === 0
          this.offset += this.limit
          this.qnaList = this.qnaList.concat(resList)
        })
    },
    qnaStatusClass (item) {
      const statusId = get(item, 'statusid', '')
      let className = 'badge ui'
      switch (statusId) {
        case '101':
          className += ''
          break
        case '102':
          className += ' warning'
          break
        case '103':
          className += ' positive'
          break
        case '104':
          className += ' positive'
          break
        case '105':
          className += ' negative'
          break
        case '106':
          className += ' negative'
          break
      }
      return className
    },
    status (item) {
      return get(item, 'status', '')
    },
    title (item) {
      return get(item, 'title', '')
    },
    regdate (item) {
      return get(item, 'regdate', '')
    },
    name (item) {
      return get(item, 'name', '')
    },
    email (item) {
      return get(item, 'email', '')
    },
    phone (item) {
      return get(item, 'phone', '')
    },
    questiontype (item) {
      return get(item, 'questiontype', '')
    },
    servicetype (item) {
      return get(item, 'servicetype', '')
    },
    programinfo (item) {
      return get(item, 'programinfo', '')
    },
    env_1 (item) {
      return get(item, 'env_1', '')
    },
    env_2 (item) {
      return get(item, 'env_2', '')
    },
    userQnaUrl () {
      if (utils.cookies.getDevice() === 'mobile') {
        let credential = utils.cookies.getCredential()
        let addParam = credential !== 'none' ? '&credential=' + encodeURIComponent(credential) : ''
        return 'https://member.wavve.com/mobile/customer/qna/ask?device=mobile' + addParam
      }
      return 'captvpooq://member/mobile/customer/qna/ask'
    },
    moveToInquiry () {
      location.href = isApp() ? 'captvpooq://customer/qna/inquiry' : 'https://member.wavve.com/mobile/customer/qna/ask?device=mobile'
    }
  }
}
</script>
